export const ADD_TO_CALENDAR_CLICKED = 'ADD_TO_CALENDAR_CLICKED'

export const addToCalendarClicked = () => ({type: ADD_TO_CALENDAR_CLICKED})
